import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex pt-5 px-10" }
const _hoisted_2 = { class: "d-flex flex-column" }
const _hoisted_3 = { class: "fs-1" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  class: "modal__content pt-5 px-lg-10 scroll scroll-x",
  style: {"max-height":"350px"}
}
const _hoisted_6 = { class: "d-block fs-5 mb-4" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h3", { class: "mt-4" }, "Stack Frames", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_ModalBase = _resolveComponent("ModalBase")!

  return (_openBlock(), _createBlock(_component_ModalBase, {
    title: "Exception Thrown",
    "has-footer": true,
    "has-header": false,
    size: "modal-xl",
    ref: "modal"
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h1", _hoisted_3, "Exception Thrown: " + _toDisplayString(_ctx.exceptionData.title), 1),
          _createElementVNode("h2", {
            class: "fs-4",
            innerHTML: _ctx.exceptionData.detail
          }, null, 8, _hoisted_4)
        ]),
        _createVNode(_component_Button, {
          onClick: _ctx.toggleClosed,
          type: "",
          class: "btn-outline-primary btn-outline btn-sm ms-auto"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Remove ")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exceptionData.exceptionDetails, (detail) => {
          return (_openBlock(), _createElementBlock("div", {
            key: detail.message
          }, [
            _createElementVNode("code", _hoisted_6, _toDisplayString(detail.message) + ": " + _toDisplayString(detail.type), 1),
            _createElementVNode("samp", {
              innerHTML: detail.raw
            }, null, 8, _hoisted_7),
            false
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _hoisted_9,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.stackFrames, (frame) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: frame.function
                    }, [
                      _createElementVNode("div", null, _toDisplayString(frame.filePath), 1),
                      _createElementVNode("div", null, _toDisplayString(frame.preContextCode), 1),
                      _createElementVNode("div", null, _toDisplayString(frame.contextCode), 1),
                      _createElementVNode("div", null, _toDisplayString(frame.postContextCode), 1)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }, 512))
}